export type NestSelectMode = 'single' | 'multiple';

export interface NestSelectOption {
  label: string,
  value: string
}
